import BillCard from "./components/HostRentBillCard";

export default function Payable() {
  const mockData = [
    {
      id: 1,
      roomNo: "A-302",
      type: "房租",
      startDate: "2025-01-01",
      endDate: "2025-01-31",
      amount: 3200,
      status: "unpaid",
    },
    {
      id: 2,
      roomNo: "B-110",
      type: "物业费",
      startDate: "2025-01-01",
      endDate: "2025-03-31",
      amount: 800,
      status: "pending",
    },
  ];
  return (
    <>
      <h2 style={{ marginBottom: 16 }}>待付账单</h2>
      {mockData.map((item) => (
        <BillCard key={item.id} bill={item} />
      ))}
    </>
  );
}
